import { isAlphaNumericKey, isNavigationKey } from '@silevis/reactgrid';
import React from 'react';
import { Dropdown, Spinner } from 'react-bootstrap';
import { handleKeyDownDefault } from '../../helpers/global';

class DropdownCellTemplate {
  getCompatibleCell(uncertainCell) {
    return {
      ...uncertainCell,
      text: uncertainCell.text || '',
      options: Array.isArray(uncertainCell.options) ? uncertainCell.options : [],
      onSelect: uncertainCell.onSelect || (() => {}),
      nonEditable: uncertainCell.nonEditable || false,
      isLoading: uncertainCell.isLoading || false,
      onClick: uncertainCell.onClick || (() => {})
    };
  }

  handleKeyDown(cell, keyCode, ctrl, shift, alt) {
    return handleKeyDownDefault(cell, keyCode, ctrl, shift, alt);
  }

  update(cell, cellToMerge) {
    return { ...cell, ...cellToMerge };
  }

  render(cell) {
    const { text, options, nonEditable, isLoading, onSelect, onClick } = cell;

    return (
      <div
        className="d-flex align-items-center w-100 px-2 justify-content-center gap-2"
        style={{ height: '100%' }}
        onKeyDown={e => {
          if (isAlphaNumericKey(e.keyCode) || isNavigationKey(e.keyCode)) {
            e.stopPropagation();
          }
        }}
        onPointerDown={e => e.stopPropagation()}
      >
        <Dropdown
          drop="down"
          onClick={e => {
            e.stopPropagation();
            onClick();
          }}
          disabled={nonEditable || isLoading}
        >
          <Dropdown.Toggle
            size="sm"
            variant="primary"
            id={`dropdown-cell-${Math.random()
              .toString(36)
              .substr(2, 5)}`}
            style={{
              fontSize: '0.85rem',
              minWidth: 'auto'
            }}
            disabled={nonEditable || isLoading}
          >
            {text || 'Select...'}
          </Dropdown.Toggle>

          {!isLoading && (
            <Dropdown.Menu
              popperConfig={{ strategy: 'fixed' }}
              style={{
                zIndex: 9999,
                padding: 0
              }}
            >
              {options.map(opt => (
                <Dropdown.Item
                  disabled={opt.value === text || opt?.label === text}
                  key={opt.value}
                  eventKey={opt.value}
                  active={opt.value === text}
                  onSelect={selectedValue => {
                    onSelect(selectedValue);
                  }}
                >
                  {opt.label}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          )}
        </Dropdown>

        <Spinner animation="border" size="sm" style={{ visibility: isLoading ? 'visible' : 'hidden' }} />
      </div>
    );
  }
}

export const dropdownCell = new DropdownCellTemplate();
